export type Base64File = {
    base64: string;
    filename: string;
};

export const fileListToBase64 = async (fileList: Array<File>) => {
    // create function which return resolved promise
    // with data:base64 string
    const getBase64 = (file: File) => {
        const reader = new FileReader();
        return new Promise(resolve => {
            reader.onload = e => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                resolve({
                    base64: e?.target?.result,
                    filename: file.name
                });
            };
            reader.readAsDataURL(file);
        });
    };

    // here will be array of promisified functions
    const promises: Array<Promise<Base64File>> = [];

    // loop through fileList with for loop
    fileList.forEach((item: File) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        promises.push(getBase64(item));
    });

    // array with base64 strings
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return await Promise.all(promises);
};
